<template>
  <nav aria-label="Pagination">
    <ul class="c-pagination">
      <li class="c-pagination__item">
        <button class="c-pagination__link--prev" type="button" rel="prev" v-bind:disabled="!showPreviousPage" v-on:click="getPreviousPageResults">
          <span class="visually-hidden">Previous page</span>
          <svg class="c-pagination__link--prev-arrow" focusable="false" aria-hidden="true">
            <use xlink:href="#prev" />
          </svg>
        </button>
      </li>
      <li class="c-pagination__item" v-if="showPreviousPage">
        <button class="c-pagination__link" type="button" v-bind:aria-label="previousPageAria" v-on:click="getPreviousPageResults">{{previousPageNumber}}</button>
      </li>
      <li class="c-pagination__item is-active">
        <span class="c-pagination__current" v-bind:aria-label="currentPageAria">{{currentPage}}</span>
      </li>
      <li class="c-pagination__item" v-if="showNextPage">
        <button class="c-pagination__link" type="button" v-bind:aria-label="nextPageAria" v-on:click="getNextPageResults">{{nextPageNumber}}</button>
      </li>
      <li class="c-pagination__item">
        <button class="c-pagination__link--next" type="button" rel="next" v-bind:disabled="!showNextPage" v-on:click="getNextPageResults">
          <span class="visually-hidden">Next page</span>
          <svg class="c-pagination__link--next-arrow" focusable="false" aria-hidden="true">
            <use xlink:href="#next" />
          </svg>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SearchPaging",
  props: {
    currentPage: {
      default: 1,
      type: Number
    },
    searchType: {
      type: String
    },
    totalPages: {
      default: 1,
      type: Number
    }
  },
  computed: {
    currentPageAria() {
      return `Current page ${this.currentPage}`;
    },
    nextPageAria() {
      return `Page ${this.nextPageNumber}`;
    },
    nextPageNumber() {
      return (this.currentPage + 1);
    },
    previousPageAria() {
      return `Page ${this.previousPageNumber}`;
    },
    previousPageNumber() {
      return (this.currentPage - 1);
    },
    showNextPage() {
      return (this.currentPage < this.totalPages);
    },
    showPreviousPage() {
      return (this.currentPage > 1);
    }
  },
  methods: {
    getNextPageResults() {
      this.$emit('getResults', this.nextPageNumber, this.searchType);
    },
    getPreviousPageResults() {
      this.$emit('getResults', this.previousPageNumber, this.searchType);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/developers/results/SearchPaging.vue